<template>
    <div class="px-4 py-8 sm:px-10">
        <p class="mb-2 text-sm">{{ translate('registrationWait.body:infoContent') }}</p>
        <p class="text-blue-800 text-sm" v-html="translate('registrationWait.body:signature')"></p>
    </div>
</template>
<script>

import translate from "../../../lang";
import {usePage} from "@inertiajs/inertia-vue3";

export default {
    props: {
        nft: Object,
    },
    setup() {
        let t = translate('auth');
        if(usePage().props.value.metaDataType) {
            t = translate('upload-' + usePage().props.value.metaDataType.type)
        }
        return {
            translate: t
        }
    }
};
</script>
